// extracted by mini-css-extract-plugin
module.exports = {"tButton":"tButton_tButton__3COC3","loader":"tButton_loader__2kobP","loading":"tButton_loading__1L2T9"};